import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DOWLOAD_COLLECTION_FEATURE_KEY, DownloadCollectionState } from './download-collection.reducer';

// Selektor für den gesamten Feature-Status
export const selectDownloadCollectionState =
  createFeatureSelector<DownloadCollectionState>(DOWLOAD_COLLECTION_FEATURE_KEY);

// Selektor für den `loading`-Status
export const selectDownloadCollectionLoading = createSelector(selectDownloadCollectionState, (state) => state.loading);

// Selektor für die heruntergeladenen Daten
export const selectDownloadCollectionData = createSelector(selectDownloadCollectionState, (state) => state.data);

// Selektor für Fehler
export const selectDownloadCollectionError = createSelector(selectDownloadCollectionState, (state) => state.error);
